export default __webpack_public_path__ + "media/move-weight-loss-no-med.18b0d576c2397a0c76be9190d2c939ea.webp";